module.exports = __webpack_public_path__ + "9d36499238aec2a64ccbeffa47812ca1.svg";